export default __webpack_public_path__ + "ba33649c56c684eeb22fb9ed8548388a.png";